var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('div',[_c('div',{staticClass:"error-code"},[_vm._v("4"),_c('span',[_vm._v("0")]),_vm._v("3")]),_c('div',{staticClass:"error-desc"},[_vm._v("当前岗位无此权限，请联系管理员")])])])
}]

export { render, staticRenderFns }